import { JsonRpcProvider, Contract } from "ethers"

const provider = new JsonRpcProvider("https://mainnet.base.org/")

export const fetchTokenMetadata = async (tokenId) => {
  const contractAddress = "0xc11f09103c575a4e898eb9a1c7bb4486b06546ce"
  const abi = [
    "function tokenURI(uint256 tokenId) public view returns (string memory)",
  ]
  const contract = new Contract(contractAddress, abi, provider)

  try {
    console.log(`Fetching metadata for token ${tokenId}...`)
    const metadataURI = await contract.tokenURI(tokenId)
    // console.log("Metadata URI:", metadataURI)
    return metadataURI
  } catch (err) {
    console.error("Detailed error:", {
      message: err.message,
      code: err.code,
      data: err.data,
      tokenId,
      contractAddress,
    })
    throw new Error(`Failed to fetch metadata: ${err.message}`)
  }
}
